import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getAddons } from "../services/mapServices";

export function useAddons(params) {
  const addons = useQuery({
    queryKey: ["addons", params],
    queryFn: () => getAddons(params),
    staleTime: FIVE_MINUTES_IN_MS,
    // eslint-disable-next-line eqeqeq
    enabled: !!params && params.mode == "marker",
  });

  return {
    addonsOptions: addons.data || [],
    isLoadingAddons: addons.isLoading,
  };
}